var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.952148H513V342.956H0V0.952148Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.626 111.312H443.532C443.532 102.459 436.354 95.2812 427.501 95.2812C418.648 95.2812 411.47 102.459 411.47 111.312H363.376C363.376 120.166 371.088 127.344 379.941 127.344H379.407C379.407 136.197 386.583 143.375 395.438 143.375C395.438 152.228 402.614 159.406 411.47 159.406H443.532C452.385 159.406 459.563 152.228 459.563 143.375C468.417 143.375 475.595 136.197 475.595 127.344H475.061C483.915 127.344 491.626 120.166 491.626 111.312Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.004 171.948H399.003V342.945H342.004V171.948Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.001 171.948H513V342.945H456.001V171.948Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.003 171.948H456.002V342.945H399.003V171.948Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.954102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZm);
export default __webpack_public_path__ + "static/media/ZM.627543479484d0774fda1e64b63271c5.svg";
export { ForwardRef as ReactComponent };